import React from "react";
import { Box, Typography, Divider, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useTranslation } from 'react-i18next';

const DeliveryLocationCard = ({ pincode, onChangeAddress }) => {
      const { t } = useTranslation();
        const isMobile = useMediaQuery('(max-width:768px)');
  
  return (
    <Box
      onClick={onChangeAddress}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        cursor: "pointer",
        transition: "background 0.3s",
        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
        minHeight: 40, // reduced height for header
      }}
    >
      <Tooltip title= {t('change_delivery_location', "Change delivery location")}>
        <IconButton size="small" color="primary">
          <LocationOnIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    {!isMobile ? (
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1 }}>
          
          {t('delivery_location', 'Delivery Location')}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {pincode ? `📍 Chennai – ${pincode}` : "Set delivery address"}
        </Typography>
      </Box>
      ) : 
      (
           
        <Typography variant="caption" color="text.secondary">
          {pincode ? `📍${pincode}` : ""}
        </Typography>
   
      )}
    </Box>
  );
};

export default DeliveryLocationCard;
